import { cn } from "@newxsystems/shared";
import { RavioliCardLink } from "../RavioliCardLink/RavioliCardLink";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import { RavioliRichText } from "../RavioliRichText/RavioliRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => {
  const Heading = headingAs;
  const effectiveColumnCount = Math.min(columnCount || 3, items.length) as 1 | 2 | 3 | 4;
  return (
    <div className={cn("grid gap-4", columns[effectiveColumnCount])}>
      {items.map((item, index) => (
        <RavioliCardLink
          className={cn(
            "flex flex-col border-primary p-2",
            index % 2 === 0 ? "bg-collection" : "bg-surface",
          )}
          key={index}
          link={item.cardLink}
        >
          <div className="flex-1 px-4 py-6 md:px-6 md:py-8">
            <Heading className="font-ravioli-display text-3xl font-semibold leading-[1.05] transition-colors group-hover:text-primary">
              {item.heading}
            </Heading>
            {item.description ? (
              <RavioliRichText
                className="mt-4 text-base text-ink-muted md:text-lg"
                content={item.description}
              />
            ) : null}
          </div>
          <RavioliMedia
            aspectRatio={imageAspectRatio || "16:9"}
            media={item.image.image}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
        </RavioliCardLink>
      ))}
    </div>
  );
};

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
